import { fork, all } from 'redux-saga/effects';

import authUserSaga from './auth-user';
import schoolSaga from './school/school';
import schoolPublicVacancy from './school/school-public-vacancy';
import vacanciesSaga from './vacancies';
import userAccountSaga from './user-account';
import passwordRecoverySaga from './password-recovery';
import userActivationSaga from './user-activation';
import applicationsSaga from './applications';
import candidateApplicationsSaga from './candidate/candidate-applications';
import candidateMoreVacanciesSaga from './candidate/candidate-more-vacancies';
import schoolCandidateSaga from './school/school-candidate';
import candidateReferencesSaga from './candidate/candidate-references';
import referencesSaga from './references';
import candidateApplicationSaga from './candidate/candidate-application';
import candidateApplicationDraftSaga from './candidate/candidate-application-draft';
import candidateProfileSaga from './candidate/candidate-profile';
import schooAdminEmailsSaga from './school-admin/emails';
import applicationsComparisonSaga from './applications-comparison';
import vacancyCloseSaga from './vacancy-close';
import schooAdminQuestionPoolSaga from './school-admin/question-pool';
import adminSchoolsSaga from './admin/admin-schools';
import adminAuditLogsSaga from './admin/admin-audit';
import adminUsersSaga from './admin/admin-users';
import candidateProfileRevisionsComparisonSaga from './candidate/candidate-profile-revisions-comparison';
import adminUsersCandidateProfileSaga from './admin/users/candidates/admin-users-candidate-profile';
import vacancyDocumentsSaga from './vacancy-documents';
import candidateApplicationDocumentsSaga from './candidate/candidate-application-documents';
import schoolCandidatePartnerSaga from './school/school-candidate-partner';
import candidateDocumentTypesSaga from './candidate/candidate-document-types';
import candidateProfileDocumentsSaga from './candidate/candidate-profile-documents';
import schoolDashboardSaga from './school/school-dashboard';
import candidateLinkSearchAssociatesAccountSaga from './candidate/candidate-link-search-associates-account';
import schoolReleaseInfoSaga from './school/school-release-info';
import vacancyAccessSaga from './vacancy-access';

export default function* root() {
  yield all([
    fork(authUserSaga),
    fork(schoolSaga),
    fork(schoolPublicVacancy),
    fork(vacanciesSaga),
    fork(userAccountSaga),
    fork(passwordRecoverySaga),
    fork(userActivationSaga),
    fork(referencesSaga),
    fork(applicationsSaga),
    fork(candidateApplicationsSaga),
    fork(candidateMoreVacanciesSaga),
    fork(candidateReferencesSaga),
    fork(schoolCandidateSaga),
    fork(candidateApplicationSaga),
    fork(candidateApplicationDraftSaga),
    fork(candidateProfileSaga),
    fork(schooAdminEmailsSaga),
    fork(applicationsComparisonSaga),
    fork(vacancyCloseSaga),
    fork(schooAdminQuestionPoolSaga),
    fork(adminSchoolsSaga),
    fork(adminAuditLogsSaga),
    fork(candidateProfileRevisionsComparisonSaga),
    fork(adminUsersCandidateProfileSaga),
    fork(adminUsersSaga),
    fork(vacancyDocumentsSaga),
    fork(candidateApplicationDocumentsSaga),
    fork(schoolCandidatePartnerSaga),
    fork(candidateDocumentTypesSaga),
    fork(candidateProfileDocumentsSaga),
    fork(schoolDashboardSaga),
    fork(candidateLinkSearchAssociatesAccountSaga),
    fork(schoolReleaseInfoSaga),
    fork(vacancyAccessSaga)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js